import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import P5Sketch from './P5Sketch';

const TextSection: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  
  // 获取滚动进度
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"]
  });
  
  // 背景层负责盖住 Hero，内容只做轻微视差 + 淡入，避免顶部留出大片空白。
  // 只用滚动进度的前 40%（即本节滑上来盖住 Hero 的阶段）。
  const y = useTransform(scrollYProgress, [0, 0.4], ["12%", "0%"]);
  const opacity = useTransform(scrollYProgress, [0.05, 0.3], [0, 1]);
  
  return (
    <div ref={sectionRef} className="relative min-h-screen bg-[#2C2721] z-20 overflow-hidden">
      <motion.div className="relative w-full h-full" style={{ y, opacity }}>
        <div className="h-full flex items-start justify-center pt-20 sm:pt-[10vh] md:pt-[12vh] pb-8 sm:pb-12 md:pb-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl sm:max-w-3xl md:max-w-4xl lg:max-w-5xl mx-auto text-center">
              <motion.p 
                className="text-[#F1EFE0] text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-black px-2 sm:px-4 md:px-6"
                style={{ 
                  fontFamily: 'Cardival-Demo, sans-serif',
                  lineHeight: '1.4',
                  textShadow: '0 0 2px rgba(255,255,255,0.3)',
                  WebkitTextStroke: '0.5px rgba(255,255,255,0.2)'
                }}
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                viewport={{ once: false, amount: 0.3 }}
              >
                I build calm technology interfaces that speed up thinking, respect attention, and leave room for curiosity.
                <br /><br />
                Currently, I'm actively seeking opportunities to apply my skills in innovative environments and contribute to cutting-edge projects in AI and software development.
              </motion.p>
              
              {/* P5.js Interactive Sketch */}
              <motion.div
                className="mt-8 sm:mt-12 md:mt-16 lg:mt-20"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.3 }}
                viewport={{ once: false, amount: 0.2 }}
              >
                <P5Sketch />
              </motion.div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default TextSection;
